import Contacts from './Contacts.vue';

export default Contacts;
